import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useTimeoutEffect } from "@/hooks/useTimeoutEffect";

import { FilterDropdownShape } from "./Filters.type";

const FilterDropdownWrapper = ({
  className,
  filterProps,
  okButtonProps,
  resetButtonProps,
  onDropdownClose,
  children,
}) => {
  const { visible, selectedKeys } = filterProps;
  const { t } = useTranslation();

  useTimeoutEffect(
    () => {
      // Callback is run with delay to make sure it is run after the dropdown
      // is completely hidden (aka after the css animation).
      if (!visible) onDropdownClose?.();
    },
    250,
    [visible, selectedKeys]
  );

  return (
    <div className={className}>
      <div className="app-table-filter-dropdown-tree">{children}</div>
      <div className="app-table-filter-dropdown-btns">
        <Button size="small" type="link" {...resetButtonProps}>
          {t("global:table:reset")}
        </Button>
        <Button size="small" type="primary" {...okButtonProps}>
          {t("global:table:ok")}
        </Button>
      </div>
    </div>
  );
};

FilterDropdownWrapper.propTypes = {
  className: PropTypes.string,
  filterProps: FilterDropdownShape,
  okButtonProps: PropTypes.object,
  resetButtonProps: PropTypes.object,
  onDropdownClose: PropTypes.func,
  children: PropTypes.node,
};

export default FilterDropdownWrapper;
